import { render, staticRenderFns } from "./DiscountDropdown.vue?vue&type=template&id=7c54fe47&scoped=true&"
import script from "./DiscountDropdown.vue?vue&type=script&lang=js&"
export * from "./DiscountDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DiscountDropdown.vue?vue&type=style&index=0&id=7c54fe47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c54fe47",
  null
  
)

export default component.exports